// Importación de la función useNavigate desde react-router-dom para la navegación en la aplicación.
import { useState, } from 'react';
import { useTheme, useMediaQuery } from "@mui/material";

import { useNavigate } from 'react-router-dom'

// Importación de componentes de terceros desde Material-UI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Grid from '@mui/material/Grid';




// Importación del servicio TodoDataService desde la ruta '../../hooks/services'
import TodoDataService from '../../hooks/services';

// Importación de imágenes y otros recursos
import Mask from '../../assets/Imagenes/Mask group.png';
import Mask2 from '../../assets/Imagenes/Mask 2.png';
import Mask5 from '../../assets/Imagenes/Mask 5.png';

import Mask3 from '../../assets/Imagenes/Mask group3.png';
import Mask4 from '../../assets/Imagenes/Mask group4.png';


import LogoMovil from '../../assets/Imagenes/LogoMovil.png';


import LogoFooter from '../../assets/Imagenes/LogoFooter.png';
import './styles.css'

// Definición de temas personalizados para estilos
let theme = createTheme();
let theme2 = createTheme();
let theme3 = createTheme();

// Configuración del tema 'theme' para el cuerpo del texto
theme.typography.body1 = {
  fontSize: '14px',
  '@media (max-width:1080px)': {
    fontSize: '12px',
  },
  '@media (max-width:920px)': {
    fontSize: '9px',
  },
  '@media (max-width:600px)': {
    fontSize: '6px',
  }
};

// Configuración del tema 'theme2' para el cuerpo del texto
theme2.typography.body2 = {
  fontSize: '18px',
  '@media (max-width:1600px)': {
    fontSize: '16px',
  },
  '@media (max-width:1300px)': {
    fontSize: '14px',
  },
  '@media (max-width:1200px)': {
    fontSize: '12px',
  },
  '@media (max-width:1000px)': {
    fontSize: '8px',
  },
  '@media (max-width:800px)': {
    fontSize: '6px',
  }
};

// Configuración del tema 'theme3' para el cuerpo del texto
theme3.typography.body1 = {
  fontSize: '20px',
  fontFamily: 'Itaca ',
  '@media (max-width:1660px)': {
    fontSize: '18px',
  },
  '@media (max-width:1545px)': {
    fontSize: '16px',
  },
  '@media (max-width:1420px)': {
    fontSize: '14px',
  },
  '@media (max-width:1310px)': {
    fontSize: '12px',
  },
  '@media (max-width:1190px)': {
    fontSize: '10px',
  },
  '@media (max-width:1080px)': {
    fontSize: '8px',
  },
  '@media (max-width:960px)': {
    fontSize: '6px',
  }
};

// Componente funcional FooterColumba
const FooterColumba = ({ ListLink, HideFoother }) => {

  // Uso del hook useNavigate para la navegación
  const navigate = useNavigate();

  // Función para manejar el clic en los enlaces
  const handleClick = (link) => {
    navigate(link);
  };

   const theme = useTheme();
  const down1400 = useMediaQuery(theme.breakpoints.down(1400));
const down1200 = useMediaQuery(theme.breakpoints.down(1200));
const down900 = useMediaQuery(theme.breakpoints.down(900));
const down600 = useMediaQuery(theme.breakpoints.down(600));



const ImgOnda = down1400 
  ? (down1200 ? Mask4 : Mask3) 
  : Mask;
  // Renderización del componente
  return (

    <Box height='302px'  >
      <Box sx={{ [theme.breakpoints.down(900)]: { display: 'none' }, [theme.breakpoints.up(900)]: { display: 'block' } }}>
     
        <Box sx={{ width: '100%', marginTop: '0%', backgroundColor: '#D14081', padding: '0px', display: 'flex', justifyConten: 'center' }}>
          <Box sx={{ width: { xs: '20%', md: '30%' }, backgroundColor: '#D14081', padding: '0px', margin: '0px' }}>
            <Box sx={{ height: '100%', display: 'grid', justifyContent: 'flex-end', alignContent: 'center' }}>
              <Button disableRipple onClick={() => (handleClick('/'))} sx={{ "&.MuiButtonBase-root:hover": { bgcolor: "transparent" } }}>
                <img height='95%' width='95%' src={LogoFooter} alt='Paloma' />
              </Button>

              <Typography variant='body1' sx={{ bottom: { md: '0%', lg: '5%', xl: '10%' }, fontWeight: '600 ! important', fontSize: { xs: '4.5px', sm: '8px', md: '12px' }, paddingLeft: '7%', paddingTop:'16px', color: '#F5F5F5', fontFamily: 'Itaca  !important' }}>
                Columba Derechos Reservados
              </Typography>
            </Box>
            {/* <Box sx={{ height: '40%', display: 'flex', justifyContent: 'flex-end', fontFamily:'itaca' }}>
              
            </Box> */}
          </Box>
          <Box sx={{ padding: '0px', margin: '0px', display: 'flex', flexDirection: 'row-reverse', width: { md: '95%', lg: '70%' } }}>
            <ImageListItem sx={{ width: '100%', height: '100%', padding: '0px', margin: '0px' }}>
              <img style={{ top: '0px',  height:'335px'}} alt='Marca' src={ImgOnda}></img>
              <Box sx={{ position: 'absolute', height: '100%', marginLeft: { xs: '35%', sm: '40%' }, width: '60%', bottom: '0%', zIndex: 23 }}>
                <Box className='CentenedorTituloCobertura'>
                  <ThemeProvider theme={theme2}>
                    <Typography  className='TituloCobertura' variant='h4'>
                      <Typography fontSize='18px' variant='h4'  display="inline" sx={{ color: '#D14081'}} >Cobertura de 50 km</Typography > a la redonda de nuestras instalaciones, sin costo adicional.
                    </Typography>
                  </ThemeProvider>
                </Box>
                <Box  sx={{ display: 'grid', alignContent: 'center' }} className='ContenidoFoother'>
                  <Box display='flex' >
                    <Box  mr='50px'>
                      <Button disableRipple onClick={() => (window.open('https://maps.app.goo.gl/LadhQG9SPew86owd7', "_blank"))} startIcon={<RoomOutlinedIcon sx={{ fontSize: { xs: '11px !important', sm: '20px !important' } }} />} className='ButtonFoother' variant="outlined">
                        {/* <ThemeProvider theme={theme3}> */}
                          <Typography className='buttonFoother' >
                            ¿Cómo llegar?
                          </Typography>
                        {/* </ThemeProvider> */}
                      </Button>
                    </Box>
                    <Box>
                      <Button disableRipple onClick={() => (window.open('tel:' + TodoDataService.GetNumberCall(), "_blank"))} startIcon={<LocalPhoneOutlinedIcon sx={{ fontSize: { xs: '11px !important', sm: '20px !important' } }} />} className='ButtonFoother ButtonFoother2' variant="outlined">
                        {/* <ThemeProvider theme={theme3}> */}
                          <Typography className='buttonFoother' >
                            Llamar
                          </Typography>
                        {/* </ThemeProvider> */}
                      </Button>
                    </Box>
                  </Box >
                  <Box sx={{ marginBottom: '15px' }}></Box>
                  <Box display='flex' >
                    <Box  mr='50px'>
                      <Button disableRipple onClick={() => (window.open(TodoDataService.GetNumberPhone(), "_blank"))} startIcon={<WhatsAppIcon sx={{ fontSize: { xs: '11px !important', sm: '20px !important' } }} />} className='ButtonFoother' variant="outlined">
                        {/* <ThemeProvider theme={theme3}> */}
                          <Typography  className='buttonFoother'>
                            WhatsApp
                          </Typography>
                        {/* </ThemeProvider> */}
                      </Button>
                    </Box>
                    <Box >
                      <Button disableRipple onClick={() => (window.open("https://www.facebook.com/funeralescolumba?mibextid=uzlsIk", "_blank"))} startIcon={<FacebookOutlinedIcon sx={{ textTransform: 'none', fontSize: { xs: '11px !important', sm: '20px !important' } }} />} className='ButtonFoother ButtonFoother2'  variant="outlined">
                        {/* <ThemeProvider theme={theme3}> */}
                          <Typography  className='buttonFoother'>
                            Facebook
                          </Typography>
                        {/* </ThemeProvider> */}
                      </Button>
                    </Box>
                  </Box >
                </Box>
          
                <Box   className='ContenidoFootherAvisos'>
                  {/* <ThemeProvider theme={theme}> */}
                    <Typography onClick={() => (handleClick('/Ayuda'))} className='ContenidoFootherAvisosT'  mr='15px'>
                      Ayuda 
                    </Typography>
                  {/* </ThemeProvider> */}
                  {/* <ThemeProvider theme={theme}> */}
                    <Typography onClick={() => (handleClick('/PreguntasFrecuentes'))}  className='ContenidoFootherAvisosT' mr='15px' >
                      FAQ 
                    </Typography>
                  {/* </ThemeProvider> */}
                  {/* <ThemeProvider theme={theme}> */}
                    <Typography onClick={() => (handleClick('/AvisoPrivacidad'))}  sx={{ whiteSpace:'nowrap' }} className='ContenidoFootherAvisosT' mr='15px' >
                      Aviso de Privacidad 
                    </Typography>
                  {/* </ThemeProvider> */}
                  {/* <ThemeProvider theme={theme}> */}
                    <Typography onClick={() => (handleClick('/TerminosCondiciones'))}  className='ContenidoFootherAvisosT'  >
                      Términos y Condiciones
                    </Typography>
                  {/* </ThemeProvider> */}
                </Box>
              </Box>
            </ImageListItem>
          </Box>
          {/* <Box sx={{ display: { xs: 'none', md: 'block' }, backgroundColor: '#FFEC00', padding: '0px', margin: '0px', width: '15%' }}></Box> */}
        </Box>
      </Box>
      <Box sx={{ [theme.breakpoints.down(900)]: { display: 'block' }, [theme.breakpoints.up(900)]: { display: 'none' } }}>


        <Box sx={{ backgroundColor: '#ffec00' }}>
          <ImageListItem>
            <img alt="imagen fondo" src={down600?Mask2:Mask5} />
            <Box sx={{ position: 'absolute', width: '100%', zIndex: 21, top: '0%' }} >

              <Box mt='75px' sx={{ display: 'flex', justifyContent: 'center' }}>
                <img onClick={() => (handleClick('/'))} style={{cursor:'pointer'}} src={LogoMovil} alt='Logo movil foother' />
              </Box>
              <Box textAlign='center' sx={{[theme.breakpoints.down(400)]:{marginTop:'20px'}, [theme.breakpoints.up(400)]:{marginTop:'50px'}}}>
                <Typography  sx={{ padding: '0% 15%', color: '#000000', fontFamily: 'Itaca  !important' }} fontSize='18px' variant='h4'>
                  <Typography display="inline"  sx={{ color: '#D14081' }} fontSize='18px' variant='h4'>Cobertura de 50 km </Typography> a la redonda de nuestras instalaciones, sin costo adicional.</Typography>

                
              </Box>
              <Box   sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center',[theme.breakpoints.down(400)]:{marginTop:'20px'}, [theme.breakpoints.up(400)]:{marginTop:'50px'} }}>


                <Button disableRipple onClick={() => (window.open('https://maps.app.goo.gl/LadhQG9SPew86owd7', "_blank"))} startIcon={<RoomOutlinedIcon sx={{ fontSize: '20px !important' }} />} sx={{ marginBottom: '16px', border: { xs: '1px solid black !important', sm: '2px solid black !important' }, textTransform: 'none', "&.MuiButtonBase-root:hover": { color: "#d14081", bgcolor: "transparent" }, width: '40%', padding: { xs: '5px' }, borderRadius: '15px', '&:hover': { borderColor: '#000000' }, borderColor: '#000000', color: '#000000' }} variant="outlined">
                  <Typography fontSize='16px !important' >
                    ¿Cómo llegar?
                  </Typography>
                </Button>

                <Button disableRipple onClick={() => (window.open('tel:' + TodoDataService.GetNumberCall(), "_blank"))} startIcon={<LocalPhoneOutlinedIcon sx={{ fontSize: '20px !important' }} />} sx={{ marginBottom: '16px', border: { xs: '1px solid black !important', sm: '2px solid black !important' }, textTransform: 'none', "&.MuiButtonBase-root:hover": { color: "#d14081", bgcolor: "transparent" }, width: '40%', padding: { xs: '5px' }, borderRadius: '15px', '&:hover': { borderColor: '#000000' }, borderColor: '#000000', color: '#000000' }} variant="outlined">
                  <Typography >
                    Llamar
                  </Typography>
                </Button>

                <Button disableRipple onClick={() => (window.open(TodoDataService.GetNumberPhone(), "_blank"))} startIcon={<WhatsAppIcon sx={{ fontSize: '20px !important' }} />} sx={{ marginBottom: '16px', border: { xs: '1px solid black !important', sm: '2px solid black !important' }, textTransform: 'none', "&.MuiButtonBase-root:hover": { color: "#d14081", bgcolor: "transparent" }, width: '40%', padding: { xs: '5px' }, borderRadius: '15px', '&:hover': { borderColor: '#000000' }, borderColor: '#000000', color: '#000000' }} variant="outlined">
                  <Typography >
                    WhatsApp
                  </Typography>
                </Button>

                <Button disableRipple onClick={() => (window.open("https://www.facebook.com/funeralescolumba?mibextid=uzlsIk", "_blank"))} startIcon={<FacebookOutlinedIcon sx={{ textTransform: 'none', fontSize: '20px !important' }} />} sx={{ marginBottom: '16px', border: { xs: '1px solid black !important', sm: '2px solid black !important' }, textTransform: 'none', "&.MuiButtonBase-root:hover": { color: "#d14081", bgcolor: "transparent" }, width: '40%', padding: { xs: '5px' }, borderRadius: '15px', '&:hover': { borderColor: '#000000' }, borderColor: '#000000', color: '#000000' }} variant="outlined">
                  <Typography >
                    Facebook
                  </Typography>
                </Button>
              </Box>

              <Box  sx={{[theme.breakpoints.down(400)]:{marginTop:'20px'}, [theme.breakpoints.up(400)]:{marginTop:'30px'}}} textAlign='center'>

                   <Typography mt='10px'  onClick={() => (handleClick('/Ayuda'))} variant='body1' sx={{ cursor: 'pointer', color: '#000000', fontFamily: 'Itaca  !important' }}  >
                      Ayuda 
                    </Typography>
                    <Typography mt='10px' onClick={() => (handleClick('/PreguntasFrecuentes'))} variant='body1' sx={{ cursor: 'pointer', color: '#000000', fontFamily: 'Itaca  !important' }}  >
                      FAQ 
                    </Typography>
                <Typography mt='10px' onClick={() => (handleClick('/AvisoPrivacidad'))} variant='body1' sx={{ cursor: 'pointer', color: '#000000', fontFamily: 'Itaca  !important' }}  >
                      Aviso de Privacidad 
                    </Typography>
                <Typography mt='10px'  onClick={() => (handleClick('/TerminosCondiciones'))} variant='body1' sx={{ cursor: 'pointer', color: '#000000', fontFamily: 'Itaca  !important' }}  >
                      Términos y Condiciones
                    </Typography>
              </Box>
            </Box>
          </ImageListItem>
        </Box>
      </Box>
    </Box>
  );
}

// Exportación del componente FooterColumba
export default FooterColumba;
